import * as React from 'react'
import { MarkerClusterer } from '@react-google-maps/api'
import { IPoint } from '../../../../interfaces/types.ts'
import { useSnapshot } from 'valtio'
import { dataState } from '../../../../store/dataState.ts'
import { historyState } from '../../../../store/historyState.ts'
import { NumberMarker } from './NumberMarker.tsx'

interface Props {

}
// randy@newportave.com|woofwoof@gibitechnologies.com
const clusterOptions = {
    // imagePath:
    //     'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // Path to the cluster icons
    // gridSize: 30,
    minimumClusterSize: 2,
    maxZoom: 17
};

export const ClusterMarker: React.FC<Props> = () => {
    const locations = (useSnapshot(historyState) as typeof historyState).locations
    const pets = (useSnapshot(dataState) as typeof dataState).pets
    const map = (useSnapshot(historyState) as typeof historyState).map
    
    // Fit bounds only when locations change, not on every render.
    // Previously fitBounds was called inside the render loop on every marker,
    // which would override any zoom change (e.g. from zoom buttons) immediately.
    React.useEffect(() => {
        if (!map || !locations?.length) return
        const bounds = new google.maps.LatLngBounds()
        let hasValid = false
        locations.forEach((point: IPoint) => {
            if (point.properties.status) {
                bounds.extend({
                    lat: point.properties.latitude,
                    lng: point.properties.longitude,
                })
                hasValid = true
            }
        })
        if (hasValid) {
            map.fitBounds(bounds)
        }
    }, [locations, map])
    
    let cluster = null
    
    if (locations?.length) {
        cluster = (
            <MarkerClusterer options={clusterOptions}>
                {(clusterer) =>
                    <div>{
                        locations.map((point: IPoint, i: number) => {
                            const latLng = new google.maps.LatLng({
                                lat: point.properties.latitude,
                                lng: point.properties.longitude,
                            })
                            if (point.properties.status) {
                                const pet = pets.find(pet => pet._id === point.properties.itemId)
                                return <NumberMarker
                                    key={`${point.properties.deviceId}-${i}`}
                                    point={point}
                                    color={pet?.iconColor || ''}
                                    num={(i % 10) + 1}
                                    position={latLng}
                                    clusterer={clusterer}
                                />
                            } else {
                                return null
                            }
                        }).filter(n=>n)
                    }</div>
                }
            </MarkerClusterer>
        )
    }
    return cluster
}
